import { createGlobalStyle } from "styled-components";

const GlobalStyles = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    font-family: Roboto, fantasy;
    font-weight: 400;
    -webkit-touch-callout: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  }
  body {
    color: ${(props) => props.theme.textSecondary};
    background-color: ${(props) => props.theme.background};
    -ms-user-select:none;
    -moz-user-select:none;
    -webkit-user-select:none;
    -webkit-touch-callout: none;
    -khtml-user-select: none;
    user-select:none;
    -webkit-touch-callout: none;
    -ms-touch-action: manipulation;
  touch-action: manipulation;
  overflow: hidden;
  font-size: 20px;
  }
`;
export default GlobalStyles;
